import React from 'react';
import { IS_DEV_API } from '../config/apiConfig';

const DevLabel = () => {
  if (!IS_DEV_API) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 12,
        right: 16,
        zIndex: 9999,
        backgroundColor: '#FF5722',
        color: '#FFFFFF',
        fontWeight: 700,
        fontSize: 11,
        letterSpacing: 1.5,
        padding: '3px 10px',
        borderRadius: 4,
        pointerEvents: 'none',
        boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
        userSelect: 'none'
      }}
    >
      DEV API
    </div>
  );
};

export default DevLabel;
